import React, { useEffect, useState } from "react";
import { useUserContext } from "../utils/hooks/UserContext";
import { useNavigate } from "react-router-dom";
import { readNotification } from "../utils/api";

const NotificationDropdown = () => {
  const { user, fetchNotifications, unreadNotification } = useUserContext();
  const navigate = useNavigate();
  const [isMarking, setIsMarking] = useState(false);

  console.log("userssss", user);

  const handleNotificationClick = async () => {
    // Only mark as read if there are unread notifications
    if (unreadNotification > 0 && !isMarking) {
      setIsMarking(true);
      try {
        await readNotification();
        // Fetch updated notifications to update the badge count
        await fetchNotifications();
      } catch (error) {
        console.error("Error marking notifications as read:", error);
      } finally {
        setIsMarking(false);
      }
    }
    
    // Navigate to the appropriate notifications page
    const notificationPath = user?.userType === "coach" ? "/coach/notifications" : "/user/notifications";
    navigate(notificationPath);
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onClick={handleNotificationClick}
        className="relative transition rounded-full hover:opacity-80"
        disabled={isMarking}
      >
        <img src="/bell.png" className="min-w-[1.5rem] max-w-[1.6rem]" alt="Notifications" />

        {unreadNotification > 0 && (
          <span className="absolute top-0 right-0 block w-4 h-4 text-xs leading-4 text-center text-white bg-red-500 rounded-full shadow-md">
            {unreadNotification}
          </span>
        )}
      </button>
    </div>
  );
};

export default NotificationDropdown;
